/* eslint-disable jsx-a11y/alt-text */
import { findMap, findCiv } from '../helpers/drafting';
import classNames from 'classnames';

export function MatchGame({ game }) {

    const mapDetails = findMap(game.map, { withFallback: true });
    const leftCivDetails = game.leftCivs.map(civ => findCiv(civ, { withFallback: true }));
    const rightCivDetails = game.rightCivs.map(civ => findCiv(civ, { withFallback: true }));

    return (
        <div className='flex flex-row series-game'>
            <div className='series-civPicks series-leftPicks'>
                {leftCivDetails.map(civ => (
                    <div className='series-civContainer'>
                        <img
                            className={classNames(
                                'series-civPick series-leftPick',
                                game.state === 'right' && 'series-civLose'
                            )}
                            src={civ.draftFlag}
                        />
                    </div>
                ))}
            </div>

            <div className='series-map'>
                <img className="m-auto series-map" src={mapDetails.iconUrl} />
            </div>

            <div className='series-civPicks series-rightPicks'>
                {rightCivDetails.map(civ => (
                    <div className='series-civContainer'>
                        <img
                            className={classNames(
                                'series-civPick series-rightPick',
                                game.state === 'left' && 'series-civLose'
                            )}
                            src={civ.draftFlag}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};
